import { atom } from "recoil";

// create userAtom
export const userAtom = atom( {
  key: "userAtom",
  default: null
} );